"use client";

import { logError } from "./../logging/logger";
import Link from "next/link";
import { useEffect } from "react";

type ErrorProps = {
  error: Error;
};

export default function ErrorPage({ error }: ErrorProps) {
  useEffect(() => {
    logError(error);
  }, [error]);

  return (
    <div className="h-screen flex flex-col items-center font-montserrat">
      <div className="text-black bg-white dark:text-white dark:bg-black flex flex-col items-center px-4 max-w-900 grow w-full">
        <div className="grow max-w w-full flex flex-col">
          <div className="flex flex-col h-full justify-center">
            <div className="grow flex flex-col items-center justify-center space-y-6 mb-4">
              <p className="text-2xl md:text-3xl text-gray-800 text-center">
                {error?.message}
              </p>
              <div className="div flex min-w-min space-x-2 items-center mt-2">
                <div className="grow" />
                <Link href={"https://groq.com/"}>
                  <p className="text-orange font-semibold">GROQ.COM</p>
                </Link>
                <span className="text-light-gray text-sm">|</span>

                <Link href={"https://groq.com/contact/"}>
                  <p className="text-orange font-semibold">CONTACT US</p>
                </Link>
                <div className="grow" />
              </div>
            </div>
            <div style={{ width: "24px" }} />
          </div>
        </div>
      </div>
    </div>
  );
}
